import React from "react";
import { useTranslation } from "react-i18next";

function Shep() {
  const [t] = useTranslation();
  return (
    <>
      <section
        className="steps-area p-relative"
        style={{ backgroundColor: "#75124f" }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div
                className="section-title mb-35 wow fadeInDown animated"
                data-animation="fadeInDown"
                data-delay=".4s"
              >
                <h2>{t("features.bigTitle")}</h2>
                <p>{t("features.bigOpis")}</p>
              </div>
              <ul className="pr-20">
                <li>
                  <div
                    className="step-box wow fadeInUp animated"
                    data-animation="fadeInUp"
                    data-delay=".4s"
                  >
                    <div className="dnumber">
                      <div className="date-box">
                        <img src="assets/img/icon/fea-icon01.png" alt="icon" />
                      </div>
                    </div>
                    <div className="text">
                      <h3>{t("features.title1")}</h3>
                      <p>{t("features.opis1")}</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div
                    className="step-box wow fadeInUp animated"
                    data-animation="fadeInUp"
                    data-delay=".4s"
                  >
                    <div className="dnumber">
                      <div className="date-box">
                        <img src="assets/img/icon/fea-icon02.png" alt="icon" />
                      </div>
                    </div>
                    <div className="text">
                      <h3>{t("features.title2")}</h3>
                      <p>{t("features.opis2")}</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div
                    className="step-box wow fadeInUp animated"
                    data-animation="fadeInUp"
                    data-delay=".4s"
                  >
                    <div className="dnumber">
                      <div className="date-box">
                        <img src="assets/img/icon/fea-icon03.png" alt="icon" />
                      </div>
                    </div>
                    <div className="text">
                      <h3>{t("features.title3")}</h3>
                      <p>{t("features.opis3")}</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div className="col-lg-6 col-md-12">
              <div
                className="step-img wow fadeInLeft animated"
                data-animation="fadeInLeft"
                data-delay=".4s"
              >
                <img
                  src="assets/img/bg/programi-img-1.webp"
                  alt="naslovna-slika"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Shep;
